module.exports = __webpack_public_path__ + "img/1525893790.ab0fa11a.jpg";